import axios, { isCancel, AxiosError, } from "axios";
import axiosRetry from "axios-retry";
import { AsyncRequest } from "./asyncRequest";
const isUrlExcludedForRefresh = (url) => ["/refresh", "/verify", "/logout"].some((excludedUrl) => url.includes(excludedUrl));
export const buildApi = (baseURL) => {
    const api = axios.create({
        baseURL,
        withCredentials: true,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
    let refreshingPromise;
    api.interceptors.response.use((response) => response, (error) => {
        if (error.code === AxiosError.ERR_CANCELED) {
            return;
        }
        const { response, config } = error;
        if (response &&
            response.status === 401 &&
            response.data.error_code === 407) {
            window.location.href = "/logout";
            return Promise.resolve({});
        }
        if (response &&
            response.status === 401 &&
            !isUrlExcludedForRefresh(config.url)) {
            if (!refreshingPromise) {
                refreshingPromise = axios
                    .post(`${baseURL}/v5/session/refresh`, {}, { withCredentials: true })
                    .catch((error) => {
                    window.location.href = "/logout";
                    return Promise.reject(error);
                })
                    .finally(() => {
                    refreshingPromise = null;
                });
            }
            return refreshingPromise.then(() => {
                return api(config);
            });
        }
        return Promise.reject(error);
    });
    axiosRetry(api, {
        retries: 3,
        retryDelay: () => 200,
        retryCondition: (error) => {
            if (isCancel(error)) {
                return false;
            }
            if (error instanceof AxiosError) {
                const isTimeout = error.code === "ECONNABORTED";
                const isNetworkError = error.message === "Network Error";
                const isServerError = error.response?.status
                    ? error.response.status >= 500 && error.response.status < 600
                    : false;
                return isTimeout || isNetworkError || isServerError;
            }
            return false;
        },
    });
    const extendedApi = Object.assign(api, {
        getAsync: async (url, config) => {
            const { asyncRequest: asyncRequestOptions, ...axiosConfig } = config || {};
            const asyncRequest = new AsyncRequest(api, asyncRequestOptions);
            return asyncRequest.execute({ ...axiosConfig, url });
        },
    });
    return extendedApi;
};
